"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalConfigurationModule = void 0;
const context_1 = require("@derivation-tech/context");
const utils_1 = require("../../utils");
const localConfig = __importStar(require("./config/local.json"));
const goerliConfig = __importStar(require("./config/goerli.json"));
const polygonConfig = __importStar(require("./config/polygon.json"));
const scrollConfig = __importStar(require("./config/scroll.json"));
const lineaConfig = __importStar(require("./config/linea.json"));
const arbitrumConfig = __importStar(require("./config/arbitrum.json"));
const blastsepoliaConfig = __importStar(require("./config/blastsepolia.json"));
const blastConfig = __importStar(require("./config/blast.json"));
const baseConfig = __importStar(require("./config/base.json"));
const monadTestnetConfig = __importStar(require("./config/monadTestnet.json"));
const configuration_base_module_1 = require("./configuration.base.module");
class LocalConfigurationModule extends configuration_base_module_1.ConfigurationModuleBase {
    async getConfig() {
        switch (this.context.chainId) {
            case context_1.CHAIN_ID.LOCAL: {
                return (0, utils_1.loadConfig)(localConfig);
            }
            case context_1.CHAIN_ID.GOERLI: {
                return (0, utils_1.loadConfig)(goerliConfig);
            }
            case context_1.CHAIN_ID.POLYGON: {
                return (0, utils_1.loadConfig)(polygonConfig);
            }
            case context_1.CHAIN_ID.SCROLL: {
                return (0, utils_1.loadConfig)(scrollConfig);
            }
            case context_1.CHAIN_ID.LINEA: {
                return (0, utils_1.loadConfig)(lineaConfig);
            }
            case context_1.CHAIN_ID.ARBITRUM: {
                return (0, utils_1.loadConfig)(arbitrumConfig);
            }
            case context_1.CHAIN_ID.BLASTSEPOLIA: {
                return (0, utils_1.loadConfig)(blastsepoliaConfig);
            }
            case context_1.CHAIN_ID.BLAST: {
                return (0, utils_1.loadConfig)(blastConfig);
            }
            case context_1.CHAIN_ID.BASE: {
                return (0, utils_1.loadConfig)(baseConfig);
            }
            case context_1.CHAIN_ID.MONADTESTNET: {
                return (0, utils_1.loadConfig)(monadTestnetConfig);
            }
            default: {
                return null;
            }
        }
    }
}
exports.LocalConfigurationModule = LocalConfigurationModule;
